import React, { useMemo } from 'react';

import Category from 'components/Ui/Category';
import Subject from 'containers/Administrator/Grades/Profile/Certificates/Subjects/Subject';

const nv = ['nv', 'n/v', 'Nv', 'NV', 'N/V', 'N/v'];

const Subjects = ({ student }) => {
	const subjects = useMemo(() => {
		return student.marks.map(mark => ({
			...mark.subject,
			mark
		}));
	}, [student]);

	const problem = useMemo(() => {
		return student.marks.some(mark => nv.includes(mark.mark));
	}, [student]);

	return (
		<Category title="Mācību kursi" hide problem={problem}>
			{subjects?.map(subject =>
				<Subject key={subject.id} subject={subject} />
			)}
		</Category>
	);
};

export default Subjects;